import * as angular from 'angular';
import { Observable } from 'rxjs';

import { BugsnagHelpers } from '~/lib/bugsnag-helpers';
import { OrganizationResource } from '@mode/legacy/data-access-model-js';
import { OrganizationHelpers } from '@mode/legacy/data-access-model-js';
import { HelpDocsService, getAppName } from '@mode/shared/util-js';

export const IdentityComponent: angular.IComponentOptions = {
  controller: class {
    readonly appName = getAppName();
    private $resolve: any;
    static $inject = ['IdentityService', 'FeatureToggleService'];
    public easyIdentityCollection;
    public samlIdentityCollection;
    public organization: OrganizationResource;
    public scimProvisioningEnabled: boolean;
    private intercomChatEnabled$: Observable<boolean>;

    constructor(
      private IdentityService,
      private FeatureToggleService,
      public helpDocs: HelpDocsService
    ) {
      this.intercomChatEnabled$ = FeatureToggleService.featureIntercomChatEnabled$;
    }

    $onInit() {
      this.organization = this.$resolve.organization;
      this.scimProvisioningEnabled = OrganizationHelpers.getOrgFeatures(this.organization).scim_provisioning;

      this.IdentityService.getSamlAndEasyIdentities(this.organization)
        .then(({ easy, saml }) => {
          this.easyIdentityCollection = easy;
          this.samlIdentityCollection = saml;
        })
        .catch((err) => {
          BugsnagHelpers.notifySafely(err);
          console.error(err);
        });
    }

    handleEasyUpdate(updatedEasyIdentityCollection) {
      this.easyIdentityCollection = updatedEasyIdentityCollection;
    }
  },
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <div class="identity-component-container">

      <div ng-if="ctrl.easyIdentityCollection">
        <identity-easy
          easy-identity-collection="ctrl.easyIdentityCollection"
          on-easy-identity-update="ctrl.handleEasyUpdate($easyIdentityCollection)"
        />
      </div>

      <panel-section ng-if="ctrl.samlIdentityCollection">
        <identity-saml
          saml-identity-collection="ctrl.samlIdentityCollection"
          organization="ctrl.organization"
        />
      </panel-section>

      <div ng-if="ctrl.scimProvisioningEnabled">
        <identity-scim organization="ctrl.organization" />
      </div>
      <div ng-if="!ctrl.scimProvisioningEnabled" class="okta-not-enabled">
        SCIM integration is available for {{ctrl.appName}}. For more details on how to connect via SCIM,
        <span ng-if="!(ctrl.intercomChatEnabled$ | async)">
          contact your Account Manager.
        </span>
        <a ng-if="(ctrl.intercomChatEnabled$ | async)"
          href="{{ ctrl.helpDocs.links['https://mode.com/help/articles/contact-us/'] }}"
          target="_blank"
          rel="noopener"
          intercom-show
        >
          contact your Account Manager.
        </a>
      </div>

    </div>
  `,
};
